import stbAPIGateway from '../../../../services/stbAPIGateway';

export const postCsvTenants = async ({ rootGetters }, { clientSid, tenantInfo }) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const client = await stbApi.postHubCsvTenants(clientSid, tenantInfo);
  return client;
};
